import { useEffect, useState, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import SelectHookFormMulti from "../../../../components/SelectHookFormMulti";
import SelectHookFormMulti_1 from "../../../../components/SelectHookFormMulti_1";

import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import { selectedModule } from "../../../CarrierAgreementMgmt/ReportsDynamic/DynamicReports/atoms";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import {
  selectedColumn,
  isSelectedModule,
  addCustomReport,
  addNewReport,
  isRunCustomQuery,
} from "../atom/atoms";
import { useGetActiveRoles } from "../hooks/useGetActiveRoles";
import useGetDetailsForEdit from "../hooks/useGetDetailsForEdit";
import useGetModuleColumns from "../hooks/useGetModuleColumns";
import { useGetModules } from "../hooks/useGetModules";
import CustomReportFields from "./CustomReportFields";

interface CustomReportDetailsProp {
  rowForEdit;
}

const CustomReportDetails: React.FC<CustomReportDetailsProp> = ({
  rowForEdit,
}) => {
  const formMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = formMethods;
  const { data: Modules, isLoading: moduleIsLoading } = useGetModules();
  const [selectedColumns, setSelectedColumns] =
    useRecoilState<any>(selectedColumn);
  const [isSelectModule, setIsSelectModule] = useRecoilState(isSelectedModule);
  const isAddState = useRecoilValue(addCustomReport);
  const user = useRecoilValue(accountAtom);
  const isAddNewReport = useRecoilValue(addNewReport);
  const moduleName = useRecoilValue(selectedModule);
  const [, setIsRunQuery] = useRecoilState(isRunCustomQuery);
  const {
    mutate: mutateCols,
    data: columnData,
    isLoading: isFetching,
  } = useGetModuleColumns();

  useEffect(() => {
    if (isSelectModule && !isFetching) {
      mutateCols(watch("moduleName") ? watch("moduleName") : "");
      setIsSelectModule(false);
    }
  }, [isSelectModule, isFetching]);

  const ModuleOpt =
    Modules &&
    Modules?.map((x) => {
      return {
        label: x.moduleName,
        value: x.id,
      };
    });
  const { data: Roles, isLoading: isRolesLoading } = useGetActiveRoles();
  const RolesOpt =
    Roles &&
    Roles?.map((x) => {
      return {
        label: x.roleName,
        value: x.roleId,
      };
    });

  const OrderByOpt = [
    { label: "ASC", value: "ASC" },
    {
      label: "DESC",
      value: "DESC",
    },
  ];
  const statusOpts = [
    { label: "Active", value: true },
    {
      label: "InActive",
      value: false,
    },
  ];
  useEffect(() => {
    // if (isAddState && Roles && !watch("permissionIds")) {
    //   const permission = Roles?.filter((c) => c.roleId === user?.roleId)?.map(
    //     (x) => {
    //       return {
    //         label: x.roleName,
    //         value: x.roleId,
    //       };
    //     }
    //   );
    //   setValue("permissionIds", permission);
    // }
    if (isAddState && Modules && !watch("moduleId") && isAddNewReport) {
      const filterMod = Modules?.filter(
        (c) => c.moduleName.toLowerCase() === moduleName?.toLowerCase()
      );
      if (filterMod?.length > 0) {
        setValue("moduleName", filterMod[0]?.moduleName);
        setValue("moduleId", filterMod[0]?.id);
        setIsSelectModule(true);
      }
    }
    if (isAddState) {
      setValue("isActive", true);
    }
  }, [
    isAddState,
    watch("permissionIds"),
    Roles,
    Modules,
    watch("moduleId"),
    isAddNewReport,
  ]);

  return (
    <>
      <div>
        <div className="m-3 bg-white box-shadow rounded-lg h-full">
          <div className="text-quinary font-bold font-sans py-2 px-4">
            Report Details
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 w-full gap-y-2 gap-x-5 mb-2">
            <div className="py-2 px-4 space-y-1">
              <TextInputLabelHookForm
                type="text"
                name="reportName"
                label="Report Name:"
                register={register("reportName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                required={true}
                className={
                  errors.reportName && "border-2 border-red-500 col-span-2 "
                }
              />
              <Controller
                control={control}
                name="moduleId"
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    label="Module"
                    options={ModuleOpt}
                    field={field}
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                      setValue("moduleName", e ? e.label : "");
                      setValue("selectedColumns", null);
                      setIsSelectModule(true);
                      setIsRunQuery(false);
                    }}
                    disabled={isAddNewReport ? true : false}
                    required={true}
                    className={
                      errors.moduleId && "border-2 border-red-500 col-span-2 "
                    }
                    isLoading={moduleIsLoading}
                  />
                )}
              />
            </div>
            <div className="space-y-1 w-full text-xs">
              <div className="py-2 px-4 space-y-1">
                <Controller
                  control={control}
                  name="permissionIds"
                  render={({ field }) => (
                    <SelectHookFormMulti
                      label="Role Permission"
                      options={RolesOpt}
                      field={field}
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      className={
                        errors.rolePermissionId &&
                        "border-2 border-red-500 col-span-2 "
                      }
                      isLoading={isRolesLoading}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="selectedColumns"
                  rules={{ required: watch("moduleId") ? true : false }}
                  render={({ field }) =>
                    watch("moduleId") ? (
                      <SelectHookFormMulti_1
                        label="Select Columns"
                        options={columnData ? columnData : []}
                        field={field}
                        value={field.value ? field.value : null}
                        onChange={(e) => {
                          field.onChange(e ? e : null);
                          setSelectedColumns(e ? e : null);
                        }}
                        isRequired={watch("moduleId") ? true : false}
                        className={
                          errors.selectedColumns &&
                          "border-2 border-red-500 col-span-2 "
                        }
                        //secondDiv="md:grid-cols-3"
                        isLoading={isFetching}
                      />
                    ) : (
                      <SelectHookFormMulti_1
                        label="Select Columns"
                        options={[]}
                        field={undefined}
                        value={field.value ? field.value : null}
                        onChange={(e) => {
                          field.onChange(e ? e : null);
                          setSelectedColumns(e ? e : null);
                        }}
                        isRequired={watch("moduleId") ? true : false}
                        className={
                          errors.selectedColumns &&
                          "border-2 border-red-500 col-span-2 "
                        }
                        //secondDiv="md:grid-cols-3"
                        isLoading={isFetching}
                      />
                    )
                  }
                />
              </div>
            </div>
            <div className="space-y-1 w-full text-xs">
              <div className="py-2 px-4 space-y-1">
                <Controller
                  control={control}
                  name="orderBy"
                  rules={{ required: false }}
                  render={({ field }) => (
                    <SelectHookFormSingle
                      label="Order By"
                      options={OrderByOpt}
                      field={field}
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e ? e.value : null);
                      }}
                      className={
                        errors.orderBy && "border-2 border-red-500 col-span-2 "
                      }
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="isActive"
                  rules={{
                    required: watch("isActive")
                      ? true
                      : watch("isActive") === null
                      ? true
                      : false,
                  }}
                  render={({ field }) => (
                    <SelectHookFormSingle
                      label="Status"
                      options={statusOpts}
                      field={field}
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e ? e.value : null);
                      }}
                      required={
                        watch("isActive")
                          ? true
                          : watch("isActive") === null
                          ? true
                          : false
                      }
                      isDisabled={isAddState ? true : false}
                      className={
                        errors.isActive && "border-2 border-red-500 col-span-2 "
                      }
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        {watch("moduleId") && (
          <div className="grid items-center w-full gap-y-2 gap-x-5 mb-2">
            <CustomReportFields
              selectedColumns={selectedColumns}
              customFields={
                rowForEdit?.customFields && rowForEdit?.customFields?.length > 0
                  ? rowForEdit?.customFields
                  : undefined
              }
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CustomReportDetails;
